export default __webpack_public_path__ + "static/media/KNOWN_HOW.6c3e8c1a.pdf";